import { Box, Button, Center, Flex, Heading, Text } from '@chakra-ui/react';
import { KollectionSortType } from '@cyberkongz/api-interfaces';
import {
  customScrollbarStyles,
  Drawer,
  DrawerBottomButtonsContainer,
  pxToRem,
  Select,
  SortIcon,
  useKollections,
} from '@cyberkongz/ui';
import { useMemo } from 'react';

const OPTIONS: { value: KollectionSortType; label: string }[] = [
  { value: 'id_asc', label: 'ID Low to High' },
  { value: 'id_desc', label: 'ID High to Low' },
];

function KollectionsSortMobile() {
  const { sort, setSort, modals, toggleModal } = useKollections();

  return (
    <>
      <Flex display={['flex', 'none']} alignItems="center" gap={4} color="inherit">
        <Flex
          onClick={() => toggleModal('sort')}
          cursor="pointer"
          alignItems="center"
          fontWeight="medium"
          gap={1}
        >
          <Text>Sort</Text>
          <SortIcon width={6} height={6} />
        </Flex>
      </Flex>
      <Drawer
        open={modals.sort}
        onOpenChange={() => toggleModal('sort')}
        styles={{
          content: {
            maxWidth: 'none',
          },
          body: customScrollbarStyles,
        }}
      >
        <Box css={{ pt: 1, maxW: pxToRem(480), mx: 'auto', pb: [pxToRem(100), null, 0] }}>
          <Heading size="xs" css={{ mb: 4 }}>
            Sort
          </Heading>
          {OPTIONS.map(({ label, value }) => (
            <Flex
              key={value}
              css={{
                border: 'none',
                borderBottom: 'thin',
                py: 4,
                fontWeight: 'medium',
                fontSize: 'md',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              {label}
              <Center
                onClick={() => setSort(value)}
                css={{
                  w: 4,
                  h: 4,
                  border: 'thin',
                  borderColor: sort === value ? 'primary' : 'textSecondary',
                  borderRadius: '50%',
                }}
              >
                {sort === value ? (
                  <Box css={{ w: 2, h: 2, bg: 'primary', borderRadius: 'inherit' }} />
                ) : null}
              </Center>
            </Flex>
          ))}
        </Box>
        <DrawerBottomButtonsContainer>
          <Button width="100%" variant="display" onClick={() => toggleModal('sort')}>
            Done
          </Button>
        </DrawerBottomButtonsContainer>
      </Drawer>
    </>
  );
}

export function KollectionsSort() {
  const { sort, setSort, modals } = useKollections();

  return useMemo(
    () => (
      <>
        <Box display={['none', 'block']} zIndex={2}>
          <Select isSearchable={false} value={sort} setValue={setSort} options={OPTIONS} />
        </Box>
        <KollectionsSortMobile />
      </>
    ),
    [sort, modals.sort]
  );
}
